import { z } from 'zod';
import {
  BaseResponseSchema,
} from './primitives.js';

// ========================================
// Provider Ops — Guard Dashboard
// ========================================

export const GuardStatusSchema = z.enum(['healthy', 'degraded', 'unhealthy', 'unknown']);


export const GuardDashboardRowSchema = z.object({
  gatewaySerialNumber: z.string(),
  tenantId: z.string().nullable().optional(),
  siteId: z.string().nullable().optional(),
  deviceCategory: z.string().nullable().optional(),
  guardHeartbeatLastSeenAt: z.string().nullable().optional(),
  guardStatus: GuardStatusSchema,
  guardServiceVersion: z.string().nullable().optional(),
  currentRegistryVersion: z.string().nullable().optional(),
  currentRegistryGeneratedAt: z.string().nullable().optional(),
  lastRegistrySyncAt: z.string().nullable().optional(),
  cacheAgeSeconds: z.number().int().nullable().optional(),
  registryNeedsUpdate: z.boolean().nullable().optional(),
  targetRegistryVersion: z.string().nullable().optional(),
});


export const GuardDashboardSummarySchema = z.object({
  guardsReporting: z.number().int().min(0),
  healthy: z.number().int().min(0),
  degraded: z.number().int().min(0),
  unhealthy: z.number().int().min(0),
  needsUpdate: z.number().int().min(0),
  staleCache: z.number().int().min(0),
});


export const GuardDashboardListQuerySchema = z.object({
  tenantId: z.string().optional(),
  siteId: z.string().optional(),
  guardStatus: GuardStatusSchema.optional(),
  needsUpdate: z.enum(['true', 'false']).optional(),
  search: z.string().max(100).optional(),
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(200).default(50),
});


export const GuardDashboardListResponseSchema = BaseResponseSchema.extend({
  data: z.object({
    guards: z.array(GuardDashboardRowSchema),
    summary: GuardDashboardSummarySchema,
    nextCursor: z.string().nullable().optional(),
    count: z.number().int().min(0),
  }),
});
// Inferred types
export type GuardDashboardListQuery = z.infer<typeof GuardDashboardListQuerySchema>;
export type GuardDashboardListResponse = z.infer<typeof GuardDashboardListResponseSchema>;
export type GuardDashboardRow = z.infer<typeof GuardDashboardRowSchema>;
export type GuardDashboardSummary = z.infer<typeof GuardDashboardSummarySchema>;
export type GuardStatus = z.infer<typeof GuardStatusSchema>;
